import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RewardVerificationModalPageRoutingModule } from './reward-verification-modal-routing.module';

import { RewardVerificationModalPage } from './reward-verification-modal.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RewardVerificationModalPageRoutingModule,
    TranslateModule
  ],
  declarations: [RewardVerificationModalPage]
})
export class RewardVerificationModalPageModule { }
